"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUserManager = createUserManager;
exports.getUserManager = getUserManager;

var _reduxOidc = require("redux-oidc");

var userManager;

function createUserManager(appSettings) {
  var _window = window,
      location = _window.location;
  var redirectUri = "".concat(location.protocol, "//").concat(location.hostname).concat(location.port ? ":".concat(location.port) : '');
  userManager = (0, _reduxOidc.createUserManager)({
    checkSessionInterval: appSettings.ssoCheckSessionInterval,
    // eslint-disable-next-line @typescript-eslint/camelcase
    client_id: appSettings.ssoClientId,
    // eslint-disable-next-line @typescript-eslint/camelcase
    redirect_uri: redirectUri,
    // eslint-disable-next-line @typescript-eslint/camelcase
    post_logout_redirect_uri: redirectUri,
    // eslint-disable-next-line @typescript-eslint/camelcase
    response_type: 'token id_token',
    scope: appSettings.ssoScopes,
    authority: appSettings.ssoUrl,
    // eslint-disable-next-line @typescript-eslint/camelcase
    silent_redirect_uri: "".concat(redirectUri, "/silent-renew.html"),
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true
  });
  return userManager;
}

function getUserManager() {
  return userManager;
}